import { render, staticRenderFns } from "./StoreOptionButton.vue?vue&type=template&id=59da0a0c&scoped=true&"
import script from "./StoreOptionButton.vue?vue&type=script&lang=js&"
export * from "./StoreOptionButton.vue?vue&type=script&lang=js&"
import style0 from "./StoreOptionButton.vue?vue&type=style&index=0&id=59da0a0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59da0a0c",
  null
  
)

export default component.exports